import React from 'react';
import cx from 'classnames';
import Skeleton from '../skeleton/Skeleton';

export default function ProductSkeleton() {
  return (
    <span
      className={cx('product', 'product--skeleton')}
    >
      <div className="product__image">
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </div>

      <Skeleton width="100%" height={26} className="product__header" />
      <Skeleton width={56} height={12} className="product__starts" />
      <Skeleton width={50} height={23} className="product__price" />
    </span>
  );
};



// WEBPACK FOOTER //
// ./components/products/ProductSkeleton.js